export default {
  recherche: {
    button: {
      print: 'Imprimer les données selectionnées (publipostage)',
      printAll: 'Imprimer toutes les données',
    },
    rechercheSimple: {
      tabs: {
        contact: 'Contacts',
        personnePhysique: 'Personnes physiques',
        personneMorale: 'Personnes morales',
        instance: 'Instances',
      },
      personnePhysique: {
        search: {
          title:
            '1- Répondant aux critères suivants (Personnes physiques et contacts)',
          nom: 'Nom',
          prenoms: 'Prénom',
          raisonSociale: 'Raison sociale ou nom usuel',
        },
        list: {
          title: 'Contacts',
          headers: {
            nom: 'Nom',
            prenoms: 'Prénom',
            personneMorale: 'Personne morale',
            cotisable: 'Cotise à',
            fonction: 'Fonction',
            division: 'Division',
            telephone: 'Téléphone',
            mail: 'Mail',
            raisonSociale: 'Personne Morale',
            typeParticipant: 'Type de participant',
            contacts: 'Liste des contacts',
          },
        },
      },
      personneMorale: {
        search: {
          title: '2- Répondant aux critères suivants (Personnes morales)',
          raisonSociale: 'Raison sociale ou nom usuel',
          departement: 'Département',
        },
        list: {
          title: 'Personnes morales',
          search: {
            nomUsuel: 'Nom usuel',
            raisonSociale: 'Raison sociale',
            departement: 'Département',
            actif: 'Active',
            notFound:
              'Si vous ne trouvez pas la Personne morale souhaitée, merci de saisir une demande de création de Personne morale',
          },
          headers: {
            nomUsuel: 'Nom usuel',
            raisonSociale: 'Raison sociale',
            departement: 'Département',
            ville: 'Ville',
            telephone: 'Téléphone',
          },
        },
      },
      instance: {
        search: {
          title: '3- Répondant aux critères suivants (Instances)',
          nom: 'Nom',
          id: 'ID',
        },
        list: {
          title: 'Instances',
          search: {
            nom: 'Nom',
            typeInstance: 'Type',
          },
          headers: {
            id: 'ID',
            referent: 'Référent',
            personnePhysique: 'Gestionnaires',
            numberOfUser: 'Nombre de participants',
            nomComplet: 'Nom',
            nom: 'Nom',
            prenoms: 'Prénom',
            societe: 'Personne morale',
            fonction: 'Fonction',
            typeParticipant: 'Rôle',
          },
        },
      },
    },
    export: {
      title: {
        menu: 'Exporter ma recherche',
        contact: 'Export de contacts',
        personneMorale: 'Export de personnes morales',
        instance: 'Export d\'instances',
        directInstance: 'Export de l\'instance et de ses participants',
        contactExpire: 'Export de contacts avec date de validité dépassée',
      },
      criteres: {
        newTitre: 'Nouveau modèle d\'export (non sauvegardé)',
        titre: 'Titre',
        scopes: {
          title: 'Sélection',
          all: 'Résultats de la recherche',
          selection: 'Eléments sélectionnés',
        },
        formats: {
          title: 'Format',
          xml: 'XML',
          excel: 'Excel',
          pdf: 'PDF',
        },
        tailles: {
          title: 'Taille',
        },
        columns: {
          headers: {
            libelle: 'Colonnes',
            ordonner: 'Ordonner',
          },
        },
        criteresDisponibles: {
          title: 'Colonnes disponibles',
        },
        button: {
          add: 'Ajouter les colonnes cochées à la sélection',
          remove: 'Supprimer les colonnes cochées de la sélection',
        },
        criteresSelectionnes: {
          title: 'Colonnes à exporter',
        },
        contact: {
          civilite: 'Civilité',
          nom: 'Nom',
          prenoms: 'Prénom',
          personneMorale: 'Personne morale',
          division: 'Division',
          fonction: 'Fonction',
          domaineActivite: 'Domaine',
          titre: 'Titre',
          typeContact: 'Type de collaborateur',
          moyenContactPrefere: 'Mode d\'envoi préférentiel',
          fonctionContact: 'Fonction',
          remplacant: 'Contact en cas d\'absence',
          telephone: 'Téléphone',
          fax: 'Télécopie',
          mail: 'Mail',
          adresse: 'Adresse postale',
          dateLimiteValidite: 'Date limite de validité',
          instanceParticipant: 'Participation aux instances',
          identifiant: 'Identifiant de connexion',
          accesAgil: 'Liste des accès AGIL',
          acces: 'Liste des accès',
        },
        personneMorale: {
          raisonSociale: 'Raison sociale',
          nomUsuel: 'Nom usuel',
          maisonsMeres: 'Groupes',
          secteurActivite: 'Secteur d\'activité',
          typePersonneMorale: 'Type',
          domicilieeMDL: 'Est domiciliée MDL',
          sirenOuSiret: 'SIREN/SIRET',
          cotiseA: 'Cotise à',
          filiales: 'Filiales',
          adresse: 'Adresse postale',
          telephone: 'Téléphone',
          fax: 'Télécopie',
          mail: 'Mail',
          siteInternet: 'Site Web',
        },
        instance: {
          nom: 'Instance',
          description: 'Description',
          typeInstance: 'Type',
          dateDebut: 'Début',
          dateFin: 'Fin',
          referent: 'Contact par défaut',
          urlSharepoint: 'Site Web',
        },
        contactExpire: {
          civilite: 'Civilité',
          nom: 'Nom',
          prenoms: 'Prénom',
          personneMorale: 'Raison Sociale',
          cotiseA: 'Cotise a',
          division: 'Division',
          fonction: 'Fonction',
          domaineActivite: 'Domaine',
          titre: 'Titre',
          typeContact: 'Type de collaborateur',
          moyenContactPrefere: 'Mode d\'envoi préférentiel',
          fonctionContact: 'Fonction',
          remplacant: 'Contact en cas d\'absence',
          telephone: 'Téléphone',
          fax: 'Télécopie',
          mail: 'Mail',
          adresse: 'Adresse postale',
          dateLimiteValidite: 'Date limite de validité',
          instanceParticipant: 'Participation aux instances',
          identifiant: 'Identifiant de connexion',
          accesAgil: 'Liste des accès AGIL',
          acces: 'Liste des accès',
        },
      },
      error: {
        noSearch: 'Aucun élement à exporter',
        emptySelection: 'Aucune colonne sélectionnée',
        noFilename: 'Erreur lors de l\'export : pas de nom de fichier',
        noAttachment: 'Erreur lors de l\'export : pas de fichier',
        serverError: 'Erreur lors de l\'export',
        serverErrorWithStatus: 'Erreur lors de l\'export : {status}',
      },
    },
    mesExports: {
      list: {
        title: 'Mes exports sauvegardés',
        search: 'Rechercher',
        add: 'Nouveau modèle d\'export',
        headers: {
          titre: 'Titre',
          actions: 'Actions',
        },
      },
      results: {
        create: {
          success: 'Modèle d\'export créé avec succès',
          error: 'Erreur lors de la création du modèle d\'export',
        },
        update: {
          success: 'Modèle d\'export modifié avec succès',
          error: 'Erreur lors de la modification du modèle d\'export',
        },
        delete: {
          success: 'Modèle d\'export supprimé avec succès',
          error: 'Erreur lors de la suppression du modèle d\'export',
        },
      },
    },
    rappelLogin: {
      menu: {
        title: 'Envoi de login',
      },
      dialog: {
        title: 'Envoi du login',
        text:
          '|Vouz allez envoyer les informations de login au contact sélectionné dans votre recherche avancée.|Vouz allez envoyer les informations de login aux {count} contacts sélectionnés dans votre recherche avancée.',
        more:
          'Les utilisateurs devront utiliser la fonction \'Mot de passe oublié ?\' si nécessaire.',
        succes: 'Les informations ont été envoyées',
      },
    },
    rappelInstance: {
      menu: {
        title: 'Envoi des instances',
      },
      dialog: {
        title: 'Envoi des instances',
        text:
          '|Vouz allez envoyer les informations de login au contact sélectionné dans votre recherche avancée, ainsi que ses instances.|Vouz allez envoyer les informations de login aux {count} contacts sélectionnés dans votre recherche avancée, ainsi que ses instances.',
        more:
          'Les utilisateurs devront utiliser la fonction \'Mot de passe oublié ?\' si nécessaire.',
        succes: 'Les informations ont été envoyées',
      },
    },
    envoi: {
      menu: {
        title: 'Envoi',
      },
      title: {
        mail: 'Envoi de mail',
        sms: 'Envoi de sms',
      },
      form: {
        list: {
          title: 'Destinataires sélectionnés',
          headers: {
            status: 'Résultat de l\'envoi',
          },
        },
        message: {
          title: 'Message à envoyer',
          caracteres: '(0 caractère)|(1 caractère)|({count} caractères)',
        },
        subject: 'Objet',
        content: 'Contenu du message',
        typeEnvoi: 'Mode d\'envoi',
        typesEnvoi: {
          sms: 'SMS',
          mail: 'Mail',
        },
      },
      results: {
        ok: 'Envoi réussi',
        partiel: 'Envoi partiellement réussi',
        noop: 'Destinataires vides',
        error: {
          default: 'Erreur lors de l\'envoi',
          paramError: 'Erreur de paramétrage',
          unknown: {
            typeObjet: 'Type d\'objet non pris en charge',
            typeEnvoi: 'Mode d\'envoi non pris en charge',
          },
        },
      },
    },
  },

  rechercheAvancee: {
    question:
      'Répondant aux critères suivantes (Famille d\'information, éléments de famille, valeurs)',
    restaurer: 'Restaurer',
    criteresElement: {
      typePersonneMorale: {
        orgPublic: 'Organisme_public',
        orgPro: 'Organisme_professionnel',
        autre: 'Autre',
      },
      choixtruefalse: {
        oui: 'Oui',
        non: 'Non',
      },

      contact: {
        nom: 'Nom',
        prenom: 'Prénom',
        domaineActivite: 'Domaine d\'activité',
        fonction: 'Fonction',
        titre: 'Titre',
        typeCollaborateur: 'Type de collaborateur',
        localisation: 'Localisation',
        telfax: 'Téléphone / Fax',
        mail: 'Email',
        modeEnvoi: 'Mode d\'envoi préférentiel',
        nomContactAbsence: 'Nom du contact en cas d\'absence',
      },
      personneMorale: {
        raisonSociale: 'Raison sociale',
        sirenSiret: 'SIREN/SIRET',
        formeJuridique: 'Forme juridique',
        secteurActivite: 'Secteur d\'activité',
        raisonSocialeGroupe: 'Raison sociale du groupe',
        typePersonneMorale: 'Type de personne morale',
        cotise: 'Cotise à (raison sociale)',
        domicilie: 'Est domiciliée MDL ?',
        localisation: 'Localisation',
        telfax: 'Télephone / Fax',
        mail: 'Email',
        siteWeb: 'Site Web',
        contactDefaut: 'Contact par défaut',
        nId: 'N° Id',
      },
      instance: {
        nom: 'Nom',
        description: 'Description',
        type: 'Type',
        localisation: 'Localisation',
        telfax: 'Téléphone / Fax',
        mail: 'Email',
        siteWeb: 'Site Web',
        fonctionInstance: 'Fonction au sein de l\'instance',
        contactDefaut: 'Contact par défaut',
        nId: 'N°Id',
      },
      valeurCriteres: {
        contient: 'Contient',
        commencePar: 'Commence par',
        finirPar: 'Finir par',
        estEgal: 'Est égal à',
        estDifferent: 'Est différent de',
      },
      modeEnvoi: {
        fax: 'Fax',
        mail: 'Email',
      },
    },
  },
  contactPhysique: {
    headers: {
      nom: 'Nom',
      prenom: 'Prénom',
    },
  },
  corbeille: {
    dateSuppression: 'Date de suppression',
  },
};
